import { observer } from 'mobx-react-lite'
import { Status, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import { LINK_HIPAA_COMPLIANCE } from 'shared/constants/links'
import hipaaAddOnBanner from 'shared/assets/images/hipaa/hipaaAddOnBanner.png'
import { LearnMoreLink } from 'pages/settings/ui/LearnMoreLink/LearnMoreLink'
import styles from './styles.module.scss'

export const HipaaAddOnModalContent = observer(() => {
  return (
    <div className={styles.content}>
      <Typography variant='heading-lg' ariaLabel='HipaaAddOnModal_title' marginBottom='12px'>
        HIPAA Compliance
      </Typography>

      <div className={styles.description}>
        <Typography
          variant='body-rg-regular'
          ariaLabel='HipaaAddOnModal_description'
          color='var(--content-primary-tertiary)'
        >
          HIPAA Compliance mode enforces healthcare-grade security across your entire organization,
          protecting sensitive patient data and keeping your team audit-ready.
        </Typography>
        <LearnMoreLink
          href={LINK_HIPAA_COMPLIANCE}
          typographyProps={{ variant: 'body-rg-medium', ariaLabel: 'HipaaAddOnModal_learnMore' }}
        >
          Learn more
        </LearnMoreLink>
      </div>

      <img
        src={getCDNAssetURL(hipaaAddOnBanner)}
        alt='HIPAA Compliance'
        className={styles.banner}
      />

      <div className={styles.pricing}>
        <div className={styles.pricingCard}>
          <Typography variant='body-rg-semibold' ariaLabel='HipaaAddOnModal_payMonthlyTitle'>
            Pay monthly
          </Typography>
          <div className={styles.price}>
            <Typography variant='heading-lg' ariaLabel='HipaaAddOnModal_payMonthlyPrice'>
              $300
            </Typography>
            <Typography
              variant='body-md-regular'
              ariaLabel='HipaaAddOnModal_payMonthlyInterval'
              color='var(--content-primary-secondary)'
            >
              / month
            </Typography>
          </div>
        </div>

        <div className={styles.pricingCard}>
          <div className={styles.pricingCardHeader}>
            <Typography variant='body-rg-semibold' ariaLabel='HipaaAddOnModal_payAnnuallyTitle'>
              Pay annually
            </Typography>
            <Status title='Save $1,200' intent='positive' emphasis='high' size='label' />
          </div>
          <div className={styles.price}>
            <Typography variant='heading-lg' ariaLabel='HipaaAddOnModal_payAnnuallyPrice'>
              $200
            </Typography>
            <Typography
              variant='body-md-regular'
              ariaLabel='HipaaAddOnModal_payAnnuallyInterval'
              color='var(--content-primary-secondary)'
            >
              / month
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
})
